//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapState, mapActions } from "vuex";
import AQModal from "@/components/Generics/AQModal/AQModal.vue";
import AQCard from "@/components/Generics/AQCard/AQCard.vue";
import AQInput from "@/components/Generics/AQInput/AQInput.vue";
import AQBadge from "@/components/Generics/AQBadge/AQBadge.vue";

export default {
    name: "PlvTaskDescription",
    components: {
        AQModal,
        AQInput,
        AQBadge,
        AQCard
    },
    props: {
        taskId: { type: String, default: "" },
        perspectiveId: { type: String, default: "" },
        applicationId: { type: String, default: "" },
        detailsData: { type: Object, default: () => ({}) },
        guiDetailsData: { type: Object, default: () => ({}) },
        taskSelected: { type: Boolean, default: false }
    },
    data() {
        const vm = this;

        return {
            validUserImage: true,
            opened: true,
            readonly: true,
            currentPriorityIcon: "",
            currentPriorityColor: "",
            expirationActivityIconColor: null,
            endTypePlugin: false,
            taskDescriptionData: {},
            taskDescriptionById: {},
            listOfUsers: [],
            priorityOptions:
        [
            {
                label: vm.$t("diagrams.components.taskPriority.lowest"),
                value: "lowest",
                icon: "mdi-chevron-double-down",
                leftTextColor: "positive"
            },
            {
                label: vm.$t("diagrams.components.taskPriority.low"),
                value: "low",
                icon: "mdi-arrow-down",
                leftTextColor: "positive"
            },
            {
                label: vm.$t("diagrams.components.taskPriority.normal"),
                value: "normal",
                icon: "mdi-minus",
                leftTextColor: "warning"
            },
            {
                label: vm.$t("diagrams.components.taskPriority.high"),
                value: "high",
                icon: "mdi-arrow-up",
                leftTextColor: "negative"
            },
            {
                label: vm.$t("diagrams.components.taskPriority.highest"),
                value: "highest",
                icon: "mdi-chevron-double-up",
                leftTextColor: "negative"
            }
        ]
        };
    },
    computed: {
        ...mapGetters("apps", ["currentApp"]),
        ...mapGetters("diagrams", ["selectedPluginConfigData", "diagramConfigData", "selectedPluginUuid"]),
        ...mapGetters("admin", ["userList"]),
        ...mapGetters("reports", ["getSelectedTaskDetails", "getTaskDetailsById"]),
        ...mapState("reports", ["selectedTaskDetails"]),
        priorityValue: {
            get() {
                return this.taskDescriptionById.priority;
            }
        },
        assignedUIInput() {
            return this.taskDescriptionById.assignedUserInterface || this.guiDetailsData.name;
        },
        expirationTimeRemainingInput() {
            return this.expirationTimeRemaining || this.taskDescriptionById.expirationTimeRemaining
                || this.$t("liveView.taskDescription.expirationTimeRemaining");
        },
        priorityInput() {
            return this.taskDescriptionById.priority ? this.capitalize(this.taskDescriptionById.priority) : this.$t("liveView.taskDescription.priority");
        },
        timeRemainingInput() {
            return this.timeRemaining || this.taskDescriptionData.expirationTimeRemaining;
        },
        timeToDeadlineInput() {
            return this.timeToDeadline || this.taskDescriptionData.activityTimeToDeadline;
        },
        taskInput() {
            return this.taskDescriptionById.subject || this.taskDescriptionData.taskSubject;
        },
        instanceNameInput() {
            return this.taskDescriptionById.processInstanceName || this.taskDescriptionData.instanceName;
        },
        timeToDeadline() {
            return typeof this.taskDescriptionById.timeToDeadline === "number" ? this.convertMinsToHrsMins(this.taskDescriptionById.timeToDeadline) : null;
        },
        timeRemaining() {
            return typeof this.taskDescriptionById.timeRemaining === "number" ? this.convertMinsToHrsMins(this.taskDescriptionById.timeRemaining) : null;
        },
        expirationTimeRemaining() {
            return typeof this.taskDescriptionById.expirationTimeRemaining === "number"
                ? this.convertMinsToHrsMins(this.taskDescriptionById.expirationTimeRemaining) : null;
        },
        expirationBehaviorTranslate() {
            let retVal = "";
            if (this.taskDescriptionById.expirationBehaviour) {
                if (this.taskDescriptionById.expirationBehaviour === "AA") {
                    retVal = this.$t("liveView.taskDescription.autoApprove");
                } else if (this.taskDescriptionById.expirationBehaviour === "AR") {
                    retVal = this.$t("liveView.taskDescription.autoReject");
                } else if (this.taskDescriptionById.expirationBehaviour === "PPD") {
                    retVal = this.$t("liveView.taskDescription.pPDecision");
                } else {
                    retVal = this.taskDescriptionById.expirationBehaviour;
                }
            } else {
                retVal = this.$t("liveView.taskDescription.expirationBehaviour");
            }
            return retVal;
        }
    },
    watch: {
        getTaskDetailsById: {
            handler(val) {
                this.taskDescriptionById = val;
            },
            immediate: true
        },
        priorityValue: {
            handler(v) {
                if (v) { this.setCurrentPriorityIcon(v); }
            },
            immediate: true
        },
        detailsData: {
            handler(v) {
                if (!this.taskSelected) {
                    this.endTypePlugin = v.activityType === "GENERAL_END_PLUGIN";
                }
            },
            immediate: true
        },
        selectedPluginConfigData: {
            handler(value) {
                const tempValue = JSON.parse(JSON.stringify(value));
                if (!this.taskSelected) {
                    if (tempValue.deadline) {
                        tempValue.activityTimeToDeadline = tempValue.deadline.deadline + tempValue.deadline.timeUnit === "hours" ? "hrs" : "min";
                    }
                    this.taskDescriptionData = tempValue;
                    if (tempValue && tempValue.users) {
                        tempValue.users.user.forEach(id => {
                            this.userList.forEach(user => {
                                if (user.id === id) {
                                    this.listOfUsers.push(user);
                                }
                            });
                        });
                    }
                }
            },
            immediate: true
        }
    },
    created() {
        if (this.taskSelected) {
            this.createTaskInformationData();
        }
    },
    methods: {
        ...mapActions("reports", ["getTaskInformation"]),
        afterHide() {
            this.opened = false;
            this.$emit("closeTaskDescription");
            this.$emit("input", false);
        },
        capitalize(str) {
            return str.charAt(0).toUpperCase() + str.slice(1);
        },
        createTaskInformationData() {
            this.$store.commit("main/setTaskId", this.taskId);

            const taskPayload = {
                perspectiveId: this.perspectiveId,
                appId: this.applicationId
            };
            this.getTaskInformation(taskPayload).then(data => {
                this.taskDescriptionById = data.data;
            });
        },
        setImage(user) {
            const path = `/identity/tenants/users/image/${user.userId}/s`;
            return path;
        },
        action(action) {
            if (action === "close") {
                this.afterHide();
            }
        },
        setCurrentPriorityIcon(v) {
            this.priorityOptions.some(el => {
                if (el.value === v) {
                    this.currentPriorityIcon = el.icon;
                    this.currentPriorityColor = el.leftTextColor;
                    return true;
                }
                return false;
            });
        },
        convertMinsToHrsMins(time) {
            const sign = time < 0 ? "-" : "";
            const timeTemp = Math.abs(time);
            const days = Math.floor(timeTemp / 24 / 60);
            const hours = Math.floor((timeTemp / 60) % 24);
            const minutes = timeTemp % 60;
            return (
                sign + (days ? `${String(days)}d ` : "")
            + (hours ? `${String(hours).padStart(2, "0")}h ` : "")
            + (minutes ? `${String(minutes).padStart(2, "0")}m ` : "")
            );
        },
        getUserName(user) {
            let currentName = user.firstName || "";
            if (user.lastName) {
                currentName = `${currentName} ${user.lastName}`.trim();
            }
            if (!currentName) {
                currentName = user.email;
            }
            return currentName;
        }
    }
};
